import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  button: {
    margin: '5px 5px',
    width: 220,
    marginTop: 20
  }
};

const enhance = compose(pure);

const button = enhance(({ classes, onClickAction, title }) => {
  return (
    <Button
      variant="contained"
      color="primary"
      className={classes.button}
      onClick={onClickAction}
    >
      {title || `検索結果出力(CSV形式)`}
    </Button>
  );
});

export default withStyles(styles)(button);
